import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAppContext } from '../hooks/AppProvider';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { reducedMotion } = useAppContext();
  const initialRender = React.useRef(true);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });

    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    document.getElementById('main-content')?.focus({ preventScroll: true });
  }, [pathname, reducedMotion]);

  return null;
};

export default ScrollToTop;
